import React from 'react';
import classNames from 'classnames';

import PropTypes from 'prop-types';

import './Form.module.css';

const Select = ({ children, onChange, hasError, ...props }) => {
  return (
    <div styleName="select-wrapper">
      <select
        styleName={classNames('select', { hasError })}
        onBlur={onChange}
        onChange={onChange}
        {...props}
      >
        {children}
      </select>
    </div>
  );
};

Select.propTypes = {
  children: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        type: PropTypes.oneOf(['option', 'optgroup'])
      }),
      PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.oneOf(['option', 'optgroup'])
        })
      )
    ])
  ).isRequired,
  onChange: PropTypes.func
};

export default Select;
